var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"savedSearchBalloon"},[_c('Balloon',{attrs:{"direction":_vm.balloonDirection,"adjust":_vm.adjust}},[_c('div',{staticClass:"savedSearchBalloon__inner"},[_c('PeriodConditionLabel',{attrs:{"favorite-search":_vm.favoriteSearch,"editing-label":false}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }